import * as configUtils from "util/config";

export const CONFIG_ADMIT = "frontend.show.managementMassiveEcheq.admit.functionalities";
export const CONFIG_PAY = "frontend.show.managementMassiveEcheq.pay.functionalities";

export function isMassEcheqManagementAdmitEnabled() {
    return configUtils.getBoolean(CONFIG_ADMIT, false);
}

export function isMassEcheqManagementPayEnabled() {
    return configUtils.getBoolean(CONFIG_PAY, false);
}

export function isMassEcheqManagementEnabled() {
    return isMassEcheqManagementAdmitEnabled() || isMassEcheqManagementPayEnabled();
}

export function canAccessMassEcheqManagementForm(permissions = {}) {
    return !!permissions?.massiveEcheqManageAdmit || !!permissions?.massiveEcheqManagePay;
}
